import { useState } from "react";

const PLANS = [
  {
    name: "Pay Per Use",
    desc: "Perfect for occasional users",
    monthly: null,
    yearly: null,
    perUse: true,
    features: ["Capital Gain Report — Rs 99/report", "Bank Statement to Excel — Rs 49/file", "No subscription required", "Download instantly", "Email report option"],
    cta: "Use Now",
    highlight: false,
  },
  {
    name: "CA Plan",
    desc: "For individual Chartered Accountants",
    monthly: 999,
    yearly: 7999,
    perUse: false,
    features: ["Unlimited Capital Gain reports", "Unlimited Bank Statement conversions", "Priority processing", "All free tools included", "Email support"],
    cta: "Get CA Plan",
    highlight: true,
  },
  {
    name: "CA Firm Plan",
    desc: "For CA firms with multiple clients",
    monthly: 2499,
    yearly: 19999,
    perUse: false,
    features: ["Everything in CA Plan", "Multiple team member logins", "White-label reports with firm logo", "Client management dashboard", "Priority phone support"],
    cta: "Get Firm Plan",
    highlight: false,
  },
];

export default function Pricing() {
  const [yearly, setYearly] = useState(false);

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "48px 24px" }}>
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ fontSize: "32px", fontWeight: 800, color: "var(--text-primary)", marginBottom: "10px" }}>Simple, Transparent Pricing</h1>
        <p style={{ color: "#8C8C8C", fontSize: "15px", marginBottom: "24px" }}>Pay only for what you use, or save more with a subscription</p>

        <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", background: "white", border: "1.5px solid #EAE6E0", borderRadius: "10px", padding: "6px 16px" }}>
          <span style={{ fontSize: "14px", color: yearly ? "#8C8C8C" : "#2C2C2C", fontWeight: yearly ? 400 : 600 }}>Monthly</span>
          <button onClick={() => setYearly(!yearly)} style={{ width: "44px", height: "24px", borderRadius: "12px", background: yearly ? "#C9A84C" : "#D8D4CE", border: "none", cursor: "pointer", position: "relative", transition: "background 0.2s" }}>
            <div style={{ width: "18px", height: "18px", borderRadius: "50%", background: "white", position: "absolute", top: "3px", left: yearly ? "23px" : "3px", transition: "left 0.2s" }}></div>
          </button>
          <span style={{ fontSize: "14px", color: yearly ? "#2C2C2C" : "#8C8C8C", fontWeight: yearly ? 600 : 400 }}>
            Yearly <span style={{ background: "#E2F0D9", color: "#375623", fontSize: "11px", padding: "2px 6px", borderRadius: "4px", fontWeight: 700, marginLeft: "4px" }}>Save 33%</span>
          </span>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
        {PLANS.map((plan, idx) => (
          <div key={idx} style={{ background: "white", borderRadius: "16px", border: plan.highlight ? "2px solid #C9A84C" : "1.5px solid #EAE6E0", padding: "28px 24px", position: "relative", transition: "box-shadow 0.2s" }}>
            {plan.highlight && (
              <div style={{ position: "absolute", top: "-12px", left: "50%", transform: "translateX(-50%)", background: "#C9A84C", color: "#2C2C2C", fontSize: "11px", fontWeight: 700, padding: "4px 14px", borderRadius: "10px", whiteSpace: "nowrap" }}>
                MOST POPULAR
              </div>
            )}
            <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#2C2C2C", marginBottom: "4px" }}>{plan.name}</h3>
            <p style={{ fontSize: "13px", color: "#8C8C8C", marginBottom: "20px" }}>{plan.desc}</p>

            {plan.perUse ? (
              <div style={{ marginBottom: "24px" }}>
                <div style={{ fontSize: "28px", fontWeight: 800, color: "#C9A84C" }}>Pay as you go</div>
                <div style={{ fontSize: "13px", color: "#8C8C8C", marginTop: "4px" }}>No monthly commitment</div>
              </div>
            ) : (
              <div style={{ marginBottom: "24px" }}>
                <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                  <span style={{ fontSize: "14px", color: "#8C8C8C", fontWeight: 500 }}>Rs</span>
                  <span style={{ fontSize: "36px", fontWeight: 800, color: "#2C2C2C" }}>{yearly ? Math.round((plan.yearly || 0) / 12) : plan.monthly}</span>
                  <span style={{ fontSize: "13px", color: "#8C8C8C" }}>/month</span>
                </div>
                {yearly && <div style={{ fontSize: "12px", color: "#375623", marginTop: "4px", fontWeight: 600 }}>Billed Rs {plan.yearly}/year</div>}
              </div>
            )}

            <ul style={{ listStyle: "none", padding: 0, marginBottom: "24px", display: "flex", flexDirection: "column", gap: "10px" }}>
              {plan.features.map((f, fi) => (
                <li key={fi} style={{ display: "flex", alignItems: "flex-start", gap: "8px", fontSize: "13px", color: "#4C4C4C" }}>
                  <span style={{ color: "#C9A84C", fontWeight: 700, flexShrink: 0, marginTop: "1px" }}>✓</span>
                  {f}
                </li>
              ))}
            </ul>

            <button style={{ width: "100%", padding: "12px", background: plan.highlight ? "#C9A84C" : "transparent", color: plan.highlight ? "#2C2C2C" : "#C9A84C", border: "2px solid #C9A84C", borderRadius: "8px", fontSize: "14px", fontWeight: 700, cursor: "pointer", transition: "all 0.2s" }}
              onMouseEnter={e => { if (!plan.highlight) { e.currentTarget.style.background = "#C9A84C"; e.currentTarget.style.color = "#2C2C2C"; }}}
              onMouseLeave={e => { if (!plan.highlight) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#C9A84C"; }}}>
              {plan.cta}
            </button>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: "36px", padding: "24px", background: "white", borderRadius: "12px", border: "1px solid #EAE6E0" }}>
        <p style={{ fontSize: "14px", color: "#5C5C5C" }}>
          All plans include a <strong>7-day free trial</strong>. No credit card required for free tools.
          Questions? <a href="/contact" style={{ color: "#C9A84C", fontWeight: 600 }}>Contact us</a>
        </p>
      </div>
    </div>
  );
}
